import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assigned-raters',
  templateUrl: './assigned-raters.component.html',
  styleUrls: ['./assigned-raters.component.scss']
})
export class AssignedRatersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
